import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {Bucket} from '../../Components/Utils/Bucket';
import {format} from 'date-fns';
import {formatDuration} from '../../Support/Formatting/formatDuration';
import {formatDistance} from '../../Support/Formatting/formatDistance';
import {formatSplit} from '../../Support/Formatting/formatSplit';
import {classNames} from '../../Support/classNames';
import {Loader} from '../../Components/Utils/Loader';
import {NetworkRequestStatusView} from '../../Components/Utils/NetworkRequestStatusView';
import {PowerGraph} from './PowerGraph';
import {WorkoutCardPresenter, WorkoutCardViewModel} from './WorkoutCardPresenter';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {DownloadedIndoorWorkout} from '../../../Models/DownloadedIndoorWorkout';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';
import {GeoTrack} from '../../../Models/GeoTrack';
import {GeoTrackMap} from '../../Components/Workout/Outdoor/GeoTrackMap';
import {Link} from 'react-router-dom';

interface OwnProps {
    workoutCardViewModel: WorkoutCardViewModel;
    className?: string;
}

const WorkoutCardComponent: FunctionComponent<OwnProps & PresenterProps<WorkoutCardPresenter>> = observer(
    ({presenter, workoutCardViewModel, className}) => {
        return (
            <div className={classNames('card workoutcard', className)}>
                <div className="card-title">
                    <h5 className="d-flex justify-content-between align-items-baseline">
                        <Link to={'/workouts/show/' + workoutCardViewModel.id}>{workoutCardViewModel.title}</Link>
                        <span className="fs-6">{format(workoutCardViewModel.executedAt, 'dd-MM-yyyy')}</span>
                    </h5>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12 d-flex flex-row flex-wrap gap-1">
                            <Bucket small value={formatDuration(workoutCardViewModel.duration)} label="Duration" />
                            <Bucket small value={formatDistance(workoutCardViewModel.distance)} label="Distance" />
                            <Bucket small value={formatSplit(workoutCardViewModel.speed)} label="Ø Split" />
                        </div>
                    </div>
                    {workoutCardViewModel.executionType === WorkoutExecutionType.INDOOR && (
                        <div className="row">
                            <div className="col-12 d-flex justify-content-center workoutcard__graph">
                                <NetworkRequestStatusView<DownloadedIndoorWorkout>
                                    result={presenter.indoorDownloadResult}
                                    loader={() => <Loader />}
                                    error={() => null}
                                    component={(data) => <PowerGraph workoutIntervals={data.workoutIntervals} />}
                                />
                            </div>
                        </div>
                    )}
                    {workoutCardViewModel.executionType === WorkoutExecutionType.OUTDOOR && (
                        <div className="row">
                            <div className="col-12 d-flex justify-content-center workoutcard__graph">
                                <NetworkRequestStatusView<GeoTrack>
                                    result={presenter.geoTrackDownloadResult}
                                    loader={() => <Loader />}
                                    error={() => null}
                                    component={(geoTrack) => <GeoTrackMap height={130} geoTrack={geoTrack} />}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    },
);

export const WorkoutCard = withPresenter<WorkoutCardPresenter, OwnProps>(
    (props, component) =>
        new WorkoutCardPresenter(
            props.workoutCardViewModel,
            component.network.strokes,
            component.network.tracksDownload,
        ),
    WorkoutCardComponent,
);
